
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconTextUnderline = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M22.5 21.248h-21a1.25 1.25 0 0 0 0 2.5h21a1.25 1.25 0 0 0 0-2.5zM1.978 2.748h1.363a.25.25 0 0 1 .25.25v8.523a8.409 8.409 0 0 0 16.818 0V3a.25.25 0 0 1 .25-.25h1.363a1.25 1.25 0 0 0 0-2.5H16.3a1.25 1.25 0 0 0 0 2.5h1.363a.25.25 0 0 1 .25.25v8.523a5.909 5.909 0 0 1-11.818 0V3a.25.25 0 0 1 .25-.25H7.7a1.25 1.25 0 1 0 0-2.5H1.978a1.25 1.25 0 0 0 0 2.5z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M.5 23.998a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1H.5zM12 20c-4.411 0-8-3.589-8-8V.998H1.5a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1H5V12c0 3.86 3.14 7 7 7s7-3.14 7-7V.998h-2.5a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1H20V12c0 4.411-3.589 8-8 8z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M.75 23.998a.75.75 0 0 1 0-1.5h22.5a.75.75 0 0 1 0 1.5H.75zM12 19.5c-4.135 0-7.5-3.365-7.5-7.5V1.498h-.75a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5H6V12c0 3.308 2.692 6 6 6s6-2.692 6-6V1.498h-.75a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5h-.75V12c0 4.135-3.365 7.5-7.5 7.5z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconTextUnderline.displayName = 'IconTextUnderline';
export default IconTextUnderline;